module.exports = __webpack_public_path__ + "static/media/c-back.18f37018.svg";